export const TURNSTILE_SOURCE = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
